import XLSX from 'xlsx';
import moment from 'moment';
import { saveAs } from 'file-saver';

const createSheet = (data, columns) => {
  let dataToExport = [];
  if (data && data.length !== 0) {
    dataToExport = data.map((item) => {
      const excelItem = {};
      columns.map((column) => {
        if (column.format && column.format === 'datetime') {
          excelItem[column.header || column.key] = moment(item[column.key]).format('DD.MM.YYYY HH:mm');
        } else if (column.format && column.format === 'date') {
          excelItem[column.header || column.key] = moment(item[column.key]).format('DD.MM.YYYY');
        } else {
          excelItem[column.header || column.key] = item[column.key];
        }
        return null;
      });
      return excelItem;
    });
  }
  const headerNames = columns.map(column => column.header || column.key);
  return XLSX.utils.json_to_sheet(dataToExport, { header: headerNames });
};
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; i += 1) {
    // eslint-disable-next-line
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}
const wopts = {
  bookType: 'xlsx',
  bookSST: false,
  type: 'binary',
};

/*
 * A method to export an array of objects to an excel spreadsheet
 * documentName (Mandatory): The name of the exported document
 * data (Optional): an array of objects, if data is empty only the headers will be exported
 * columns: a sorted array of objects with the following properties:
 *  - key: Mandatory, says which key in the data should fit in each column
 *  - header: Optional, this will be the title of the column,
 *            if no header is declared the key will be the header value.
 *  - format: Optional, defaults to number / string, formats a date string if format: 'date' is set.
 * example:
 *  input:
 *    - documentName: 'test.xlsx'
 *    - data: [
 *        { foo: 'a', bar: 'b', baz: '31.12.2019' },
 *        { foo: 'aa', bar: 'bb', baz: '31.11.2019' },
 *      ]
 *    - columns: [
 *        { key: 'foo', header: 'column1' }
 *        { key: 'bar', header: 'column2' }
 *        { key: 'baz', header: 'column3', format: 'date' }
 *      ]
 *  output: an excel sheet with the name test.xlsx and the following rows / columns:
 *    | column1 | column2 | column3         |
 *    |---------|---------|-----------------|
 *    | a       | b       | 31.12.2019 00:01|
 *    |---------|---------|-----------------|
 *    | aa      | bb      | 31.11.2019 00:01|
 */
export const exportToExcel = (documentName, data, columns) => {
  const wb = XLSX.utils.book_new();
  const ws = createSheet(data, columns);
  wb.SheetNames.push(documentName);
  wb.Sheets[documentName] = ws;
  const wbout = XLSX.write(wb, wopts);

  return saveAs(
    new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
    `${documentName}.xlsx`,
  );
};

/*
 * Export a document with multiple sheets to excel format.
 * documentName (Mandatory): the name of the exported document
 * sheets (Mandatory): an array of objects with the following properties:
 *  - sheetName (Mandatory): the name of the sheet,
 *  - data (Optional): an array of objects, if data is empty only the headers will be exported
 *  - columns (Mandatory): a sorted array of objects with the following properties:
 *    - key (Mandatory): says which key in the data should fit in each column
 *    - header (Optional): the title of the column,
 *        if no header is declared the key will be the header value.
 *    - format (Optional): defaults to number / string,
 *        formats a date string if format: 'date' is set
 */

export const exportToMultipleSheetsExcel = (documentName, sheets) => {
  const wb = XLSX.utils.book_new();
  sheets.map((sheet) => {
    wb.SheetNames.push(sheet.sheetName);
    wb.Sheets[sheet.sheetName] = createSheet(sheet.data, sheet.columns);
  });
  const wbout = XLSX.write(wb, wopts);
  saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${documentName}.xlsx`);
};

export default { exportToExcel, exportToMultipleSheetsExcel };
